import { api } from "api/api";
import { AxiosError } from "axios";
import Feriado from "model/administracao/cadastro/Feriado";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class FeriadoService implements BaseServiceCadastros<Feriado> {

    pesquisar(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/feriado/pesquisar`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Feriado>((resolve, reject): void => {
            api
                .get(`/feriado/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(feriado: Feriado) {
        return new Promise<Feriado>((resolve, reject): void => {
            let url = `/feriado/incluir`;
            api
                .post(url, JSON.stringify(feriado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(feriado: Feriado) {
        return new Promise<Feriado>((resolve, reject): void => {
            api
                .put(`/feriado/editar`, JSON.stringify(feriado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/feriado/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default FeriadoService;
